module.exports = __webpack_public_path__ + "static/media/lg.e2ae089f.png";